// extracted by mini-css-extract-plugin
export default {"article":"fb9v8","line":"K1iDo","ul":"qELke","ol":"ZZA9b","alphabetical":"cenfG","alphabeticalBracketed":"xw9dI","li":"Uz5GP","checked":"yrnKo","unchecked":"IfGM9"};